module.exports = {
    name:      "twentyone",
    buildDate: "Tue Nov 19 2019 13:07:11 GMT+0000 (GMT)",
    version:   "1.0.0",
    build:     "101.2642 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 16
// module chunks = 0